module.exports = __webpack_public_path__ + "img/200-360kW分体桩.f82e1a0e.png";